import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { AlertCircle, CheckCircle, Loader2 } from 'lucide-react';
import { authAPI } from '../services/api';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [state, setState] = useState(token ? 'loading' : 'error');
  const [message, setMessage] = useState(token ? '' : 'This verification link is missing its code.');

  useEffect(() => {
    if (!token) return;
    authAPI.verifyEmail(token)
      .then(() => setState('done'))
      .catch((err) => {
        setMessage(err.response?.data?.detail || 'This verification link is invalid or has expired.');
        setState('error');
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-slate-900 dark:to-slate-800 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center" data-testid="verify-email-card">
          {state === 'loading' && <Loader2 className="w-10 h-10 animate-spin text-blue-600 mx-auto" />}
          {state === 'done' && (
            <>
              <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Email verified</h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">Your account is active. You can log in now.</p>
              <Button onClick={() => navigate('/login')} className="w-full">Go to Login</Button>
            </>
          )}
          {state === 'error' && (
            <>
              <AlertCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Couldn't verify</h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6">{message}</p>
              <Button onClick={() => navigate('/login')} className="w-full">Go to Login</Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
